// @flow
import createRavenMiddleware from 'raven-for-redux'

import initRaven from './sentryConfig'

const Raven = initRaven()
// adding context to senrty logger
const stateTransformer = (state: Object) => ({
  ...state,
  context: {
    referrer: document.referrer,
    location: document.location.href,
  },
})

export default createRavenMiddleware(Raven, { stateTransformer })



// WEBPACK FOOTER //
// ./src/sentry.js